import React from 'react';
import { useTranslation } from 'react-i18next';

import './BetslipPopup.scss';

export default function BetslipPopupClipboard() {
  const { t } = useTranslation();

  return (
    <div className="betslip-popup__content">
      <div className="betslip-popup__code">{ t('betslip.clipboard') }</div>
    </div>
  );
}
